import { io, Socket } from "socket.io-client";
import { getAccessToken } from "./client";

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (socket?.connected) return socket;

  // Disconnect existing socket before creating a new one
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
  }

  const token = getAccessToken();
  const baseUrl = import.meta.env.VITE_API_URL || "";

  socket = io(baseUrl, {
    auth: { token },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });

  socket.on("connect_error", (err) => {
    console.warn("[Socket.IO] Connection error:", err.message);
  });

  socket.on("disconnect", () => {
    if (socket) {
      const freshToken = getAccessToken();
      if (freshToken) {
        (socket as any).auth = { token: freshToken };
      }
    }
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
